export default __webpack_public_path__ + "static/media/yamunotritemple.38dc0cf1.jpg";